import { AppPermission, CLIENT_ID } from '../constants';

export const getAppPermissions = <T extends string>(InsightClaims: string) => {
    return InsightClaims.split(' ').filter(p => p.startsWith(CLIENT_ID)) as AppPermission<T>[];
};
